













import mixins from 'vue-typed-mixins';
import BookshelfFormVue from '@/components/resource/BookshelfForm.vue';
import ResourceUtils, { Bookshelf, Resource } from '@/utils/ResourceUtils';
export default mixins().extend({
  components: {
    BookshelfForm: BookshelfFormVue,
  },

  data(): {
    item?: Partial<Bookshelf>;
    resources?: Resource[];
  } {
    return {
      item: {
        id: undefined,
        name: this.$languageobj(),
        notes: undefined,
        layout: [],
      },
      resources: undefined,
    };
  },

  mounted() {
    this.loadResources(); // async load resources
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await ResourceUtils.api.bookshelf.add(this.item);
          await this.$router.push({ name: 'bookshelf-list' });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },

    async loadResources() {
      try {
        this.$alert.hide('loadResources');
        this.resources = await ResourceUtils.api.resource.list();
      } catch (error) {
        this.$alert.show('loadResources', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
